import { render, staticRenderFns } from "./tagConfig.vue?vue&type=template&id=4e2c7fb4&scoped=true"
import script from "./tagConfig.vue?vue&type=script&lang=js"
export * from "./tagConfig.vue?vue&type=script&lang=js"
import style0 from "./tagConfig.vue?vue&type=style&index=0&id=4e2c7fb4&prod&lang=scss&scoped=true"
import style1 from "./tagConfig.vue?vue&type=style&index=1&id=4e2c7fb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2c7fb4",
  null
  
)

export default component.exports